import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SyllabusQuery, SyllabusService } from '@examdojo/category/v2';
import { ReferenceQuestionService } from '@examdojo/reference-question';
import { catchError, first, of, switchMap } from 'rxjs';
import { CmsUrlParts } from '../cms/cms.model';

export const legacyReferenceQuestionRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const referenceQuestionService = inject(ReferenceQuestionService);
  const syllabusService = inject(SyllabusService);
  const syllabusQuery = inject(SyllabusQuery);

  const referenceQuestionId: string = route.params['id'];

  if (!referenceQuestionId) {
    return router.createUrlTree([`/${CmsUrlParts.Overview}`]);
  }

  return syllabusService.fetchSyllabuses().pipe(
    first(),
    switchMap(() =>
      referenceQuestionService.fetchSyllabusIdByReferenceQuestionId(parseInt(referenceQuestionId, 10)).pipe(
        switchMap((syllabusId) => {
          if (!syllabusId) {
            return of(router.createUrlTree([`/${CmsUrlParts.Overview}`]));
          }

          const syllabus = syllabusQuery.getEntity(syllabusId);

          if (!syllabus) {
            return of(router.createUrlTree([`/${CmsUrlParts.Overview}`]));
          }

          return of(
            router.createUrlTree([
              `/${CmsUrlParts.Syllabus}`,
              syllabus.slug,
              CmsUrlParts.ReferenceQuestions,
              referenceQuestionId,
            ]),
          );
        }),
        catchError(() => of(router.createUrlTree([`/${CmsUrlParts.Overview}`]))),
      ),
    ),
  );
};
